import React, { useEffect, useState } from 'react';
import Header from "../components/Header";
import Footer from "../components/Footer";
import { NavLink } from "react-router-dom";
import { getEventsinner } from "../Service/Api";
import LazyLoad from 'react-lazyload';

const formatDate = (dateString) => {
    if (!dateString) return '';

    const date = new Date(dateString);
    if (isNaN(date)) return '';

    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();

    return `${day}/${month}/${year}`;
};

function EventsInner() {
    const [data, setData] = useState([]);
    const [filteredData, setFilteredData] = useState([]);

    const [selectedYear, setSelectedYear] = useState("All");
    const [selectedMonth, setSelectedMonth] = useState("All");

    const [monthOptions, setMonthOptions] = useState(["All"]);
    const [yearRanges, setYearRanges] = useState(["All"]);

    const [searchQuery, setSearchQuery] = useState("");
    const [visibleCount, setVisibleCount] = useState(5);

    const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
        "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

    // 🔥 FETCH DATA
    useEffect(() => {
        const fetchData = async () => {
            try {
                const galleryData = await getEventsinner();

                // ✅ FIX: correct key (schoolcode instead of school)
                const seniorData = galleryData.filter(
                    item => item.schoolcode === "SMNSB"
                );

                setData(seniorData);

                // YEARS
                const uniqueYears = Array.from(new Set(
                    seniorData
                        .map(item => item.date && new Date(item.date).getFullYear())
                        .filter(Boolean)
                )).sort((a, b) => b - a);

                setYearRanges(["All", ...uniqueYears.map(String)]);

                // MONTHS
                const uniqueMonths = Array.from(new Set(
                    seniorData
                        .map(item => item.date && new Date(item.date).getMonth())
                        .filter(m => m !== null && m !== undefined)
                )).sort((a, b) => a - b);

                setMonthOptions(["All", ...uniqueMonths.map(m => monthNames[m])]);

            } catch (error) {
                console.error("Error fetching events:", error);
            }
        };

        fetchData();
    }, []);

    // 🔥 FILTER LOGIC
    useEffect(() => {
        let result = [...data];

        if (selectedYear !== "All") {
            result = result.filter(item =>
                item.date &&
                new Date(item.date).getFullYear().toString() === selectedYear
            );
        }

        if (selectedMonth !== "All") {
            result = result.filter(item =>
                item.date &&
                monthNames[new Date(item.date).getMonth()] === selectedMonth
            );
        }

        if (searchQuery.trim()) {
            result = result.filter(item =>
                item.title?.toLowerCase().includes(searchQuery.toLowerCase())
            );
        }

        result.sort((a, b) => new Date(b.date) - new Date(a.date));

        setFilteredData(result);
        setVisibleCount(5);

    }, [selectedYear, selectedMonth, searchQuery, data]);

    return (
        <>
            <Header />

            <section className="inr-header">
                <div className="container">
                    <div className="inr-header-content">
                        <h1 className="title">Upcoming Events</h1>
                        <ul className="breadcrumb">
                            <li><NavLink to="/">Home</NavLink></li>
                            <li>Upcoming Events</li>
                        </ul>
                    </div>
                </div>
            </section>

            <section className="innerBody">
                <div className="container them-container">
                    <div className="row">
                        <div className="col-12">
                            <h1>Upcoming Events</h1>
                        </div>

                        <div className='col-12'>
                            <div className="searchbox1">
                                <div className="dynamicdiv">

                                    <div>Total Events: {filteredData.length}</div>

                                    <div>
                                        Select Year
                                        <select id='ddyears'
                                            value={selectedYear}
                                            onChange={(e) => setSelectedYear(e.target.value)}
                                            className="yearSelection"
                                        >
                                            {yearRanges.map((yr) => (
                                                <option key={yr} value={yr}>{yr}</option>
                                            ))}
                                        </select>
                                    </div>

                                    <div>
                                        Select Month
                                        <select id='ddyears'
                                            value={selectedMonth}
                                            onChange={(e) => setSelectedMonth(e.target.value)}
                                            className="monthSelect"
                                        >
                                            {monthOptions.map((month, i) => (
                                                <option key={i} value={month}>{month}</option>
                                            ))}
                                        </select>
                                    </div>

                                    <input
                                        type="text"
                                        value={searchQuery}
                                        onChange={(e) => setSearchQuery(e.target.value)}
                                        placeholder="Search Here.."
                                        className="textvalue"
                                    />
                                </div>
                            </div>

                            <div className="row">
                                {filteredData.length > 0 ? (
                                    <>
                                        {filteredData.slice(0, visibleCount).map((item, index) => (
                                            <div className="events-container" key={index}>
                                                <div className="events-details">

                                                    <div className="events-img">
                                                        <LazyLoad>
                                                            <img
                                                                src={
                                                                    item.images?.length > 0
                                                                        ? `https://webapi.entab.info/api/image/${item.images[0]}`
                                                                        : 'https://webapi.entab.info/api/image/SMNSB/public/images/events.jpg'
                                                                }
                                                                alt="Event"
                                                                className="img-fluid"
                                                            />
                                                        </LazyLoad>

                                                        {item.attachments?.length > 0 && (
                                                            <a
                                                                href={`https://webapi.entab.info/api/image/${item.attachments[0]}`}
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                                className="attachment"
                                                            >
                                                                Attachment
                                                            </a>
                                                        )}
                                                    </div>

                                                    <div className="events-desc">
                                                        <h3>{item.title}</h3>

                                                        <div className="events-time">
                                                            <p>
                                                                <span>📅 {formatDate(item.date)}</span>
                                                                <span>⏰ {item.time}</span>
                                                                <span>📍 {item.venue}</span>
                                                            </p>
                                                        </div>

                                                        <p>{item.description}</p>
                                                    </div>

                                                </div>
                                            </div>
                                        ))}

                                        {visibleCount < filteredData.length && (
                                            <div style={{ textAlign: "center", marginTop: 20 }}>
                                                <button
                                                    onClick={() => setVisibleCount(prev => prev + 5)}
                                                    className="btn btn-primary"
                                                >
                                                    Load More
                                                </button>
                                            </div>
                                        )}
                                    </>
                                ) : (
                                    <p>No events found.</p>
                                )}
                            </div>

                        </div>
                    </div>
                </div>
            </section>

            <Footer />
        </>
    );
}

export default EventsInner;